import { useRecoilValue } from 'recoil';

import { useUserPreferences } from 'lib/hooks/queries/user/useUserPreferences';

import { currentPractice } from 'components/practice/practiceState';

const DEFAULT_TIMEZONE = 'America/New_York';

const useTimezone = ({ enabled = true } = {}) => {
  const practice = useRecoilValue(currentPractice);

  const { data: generalData } = useUserPreferences({
    params: { name: 'user_general' },
    dependencies: ['user_general'],
    options: { enabled }
  });

  const { data: calendarData } = useUserPreferences({
    params: { name: 'user_calendar' },
    dependencies: ['user_calendar'],
    options: { enabled }
  });

  // Primary: timezone from user_general preferences (new location)
  const generalTimezone = generalData?.preferences?.value?.timezone;

  // Legacy fallback: calendarTimezone from user_calendar preferences (old location)
  const legacyTimezone = calendarData?.preferences?.value?.calendarTimezone?.value;

  const practiceTimezone = practice?.timezone;

  return generalTimezone || legacyTimezone || practiceTimezone || DEFAULT_TIMEZONE;
};

export default useTimezone;
